'use client';

import { useEffect } from 'react';
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background p-4 relative">
      {/* Illustration in the center */}
      <Image
        src="/images/careeroffensive-error-1-min.png"
        alt="Error Illustration"
        width={200}
        height={200}
        className="mb-6 h-auto"
        priority
      />

      {/* Error Message */}
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-foreground mb-4">
          We're sorry, something went wrong.
        </h1>
        <p className="text-muted-foreground mb-6">
          Our team has been notified and is working to fix the issue.
        </p>

        {/* Buttons */}
        <div className="flex justify-center space-x-4 mt-4">
          <Button onClick={reset}>
            Try Again
          </Button>
          <Link href="/">
            <Button variant="outline">
              Go Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
} 
